import CacheManager from '@helpers/cache-helper'; // ? Using for updating cache data
const cache = new CacheManager();

addEventListener('message', (event) => {
  const dec = new TextDecoder('utf-8');

  if (event.data) {
    if (event?.data?.isEditBuffer) {
      // ! Update

      const { apiTokenBuffer, isEditBuffer, valuesBuffer } = event.data;

      const isEdit = dec.decode(isEditBuffer);
      const API_TOKEN = dec.decode(apiTokenBuffer);
      const values = JSON.parse(dec.decode(valuesBuffer));

      let url = isEdit ? `pitches/${values._id}` : 'pitches';
      url = `${process.env.REACT_APP_API_URL}/api/${url}`;
      const options = {
        method: isEdit ? 'put' : 'post',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': API_TOKEN,
        },
      };

      return fetch(url, options)
        .then((response) => {
          if (response.status >= 400) {
            console.error(
              `updatePitchFees: error status=${response.status}, statusText=${response.statusText}, for url=${url}`,
            );
          }

          // Better JSON parsing error handling.
          return response.text();
        })
        .then((text) => {
          try {
            return JSON.parse(text);
          } catch (err) {
            console.error(
              `updatePitchFees: JSON parse error from ${url} with response=${text}, err=${err}`,
            );
            throw Error(`Error while saving MH data, err=${err}`);
          }
        })
        .then((json) => {
          // ! Not transferable object
          self.postMessage(json);

          const fetchOne = `${process.env.REACT_APP_API_URL}/api/pitches/${json._id}`;
          const fetchOptions = {
            method: 'GET',
            headers: {
              'x-access-token': API_TOKEN,
            },
          };

          fetch(fetchOne, fetchOptions)
            .then((res) => {
              if (res.status >= 400) {
                console.error(
                  `fetchMh: error status=${res.status}, statusText=${res.statusText}, for url=${fetchOne}`,
                );
                const err = new Error(res.statusText);
                err.code = res.status;
                throw err;
              }

              return res.clone().json();
            })
            .then((pitch) => {
              if (pitch._id) {
                cache.addData('pitchesList', pitch);
              } else {
                cache.updateData('pitchesList', pitch);
              }
            });
        });
    } else {
      // ! Remove
      const { apiTokenBuffer, idBuffer } = event.data;

      const API_TOKEN = dec.decode(apiTokenBuffer);
      const id = dec.decode(idBuffer);

      const url = `${process.env.REACT_APP_API_URL}/api/pitches/${id}`;

      // add credentials (ie the whole bunch of cookies...) ONLY for websites that need it !
      const options = {
        method: 'DELETE',
        headers: {
          'x-access-token': API_TOKEN,
        },
      };

      return fetch(url, options)
        .then((response) => {
          if (response.status >= 400) {
            throw new Error(
              `removePitch: error status=${response.status}, statusText=${response.statusText}, for url=${url}`,
            );
          }

          // Better JSON parsing error handling.
          return response.text();
        })
        .then((text) => {
          try {
            return JSON.parse(text);
          } catch (err) {
            console.error(
              `removePitchFees: JSON parse error from ${url} with response=${text}, err=${err}`,
            );
            throw Error(`Error while removing the pitch err=${err}`);
          }
        })
        .then((json) => {
          // ! Not transferable object
          self.postMessage(json);
          cache.deleteData({ key: 'pitchesList', basic_id: id });
        })
        .catch((err) => {
          self.postMessage(
            Error(
              'This document is being deleted, it will be permanently deleted in few minutes.',
            ),
          );
        });
    }
  }
});
